/* import __COLOCATED_TEMPLATE__ from './send-follow-up-reply.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();